import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseListDirective } from 'src/app/directives/base-list.directive';
import { PrimeNGTableColumn } from 'src/app/models/AppGenericClasses';
import { AWSS3Service } from 'src/app/services/data/aws-s3.service';
import { GlobalDataService } from 'src/app/services/data/global-data.service';

import { UtilsService } from 'src/app/services/utils/utils.service';
import { Utils } from 'src/app/shared/utils/utils';

import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-user-pending-table',
  templateUrl: './user-pending-table.component.html',
  styleUrls: ['./user-pending-table.component.sass']
})
export class UserPendingTableComponent extends BaseListDirective {

  form = {
    user_id: null,
    status_: null,
    approval_status: null,
    user_credential_status_: null,
    reject: 0
  }

  override availableColumns: PrimeNGTableColumn[] = [
    new PrimeNGTableColumn('first_name', 'FORM.NAME', 150, { frozen: true }),
    new PrimeNGTableColumn('last_name', 'FORM.SURNAME', 150, { frozen: true }),
    new PrimeNGTableColumn('dni_type.name_', 'CORE.DOCUMENT-TYPE', 300),
    new PrimeNGTableColumn('email', 'AUTH.EMAIL', 200),
    new PrimeNGTableColumn('phone', 'CORE.PHONE', 200),
    new PrimeNGTableColumn('city.name_', 'CORE.CITY', 200),
    new PrimeNGTableColumn('state.name_', 'CORE.STATE', 200),
    new PrimeNGTableColumn('group.name_', 'WIDGET.GROUP', 200),
  ];
  override title = 'MENU.PENDING-PATIENTS';
  override filterableFields = ['user_id', 'first_name', 'last_name']
  override keys = {
    primary_key: 'user_id',
    label: 'first_name'
  }
  override filename = 'MENU.PENDING-PATIENTS';
  isVisibleResource = false
  pdfUrl = null
  solveDialogVisible = false

  sequentialOptions: any[] = [
    { label: 'GENERAL.YES', value: 1 },
    { label: 'GENERAL.NO', value: 0 },

  ];


  constructor(
    public utils: UtilsService,
    public data: GlobalDataService,
    protected route: ActivatedRoute,
    protected dialog: DialogService,
    protected dialogConfig: DynamicDialogConfig,
    protected dialogRef: DynamicDialogRef,
    protected s3Service: AWSS3Service,
    protected messageService: MessageService,
    private sanitizer: DomSanitizer
  ) {
    super(
      utils,
      data,
      route,
      dialog,
      dialogConfig,
      dialogRef
    )
  }

  override formatData(data: any): void {
    this.utils.applyLibraryFormat(data)
  }

  override getList(): void {
    this.query(this.data.core.usersPending()).subscribe()
  }

  override refreshActionServices(): void {
    this.inactivationService = this.data.core.libraryDelete(
      this.itemSelected[this.keys.primary_key]
    )
  }

  async onSolveDialog(row) {
    this.utils.toast.loading()

    this.itemSelected = row

    const asyncResourceUrl = await AWSS3Service.getResourceURLUser({ id: row.user_id, field: 'formula', ext: row.ext })
    switch (asyncResourceUrl.status) {
      case 1:
        this.solveDialogVisible = true
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(asyncResourceUrl.data.url);


        break;
      case 2:
        Utils.error(asyncResourceUrl.data)
        this.utils.toast.error()
        break
      default:
        break;
    }
    this.messageService.clear()


  }

  async handlePDF(item) {
    this.utils.toast.loading()
    this.itemSelected = item
    const asyncResourceUrl = await AWSS3Service.getResourceURLUser({ id: item.user_id, field: 'formula', ext: item.ext })
    switch (asyncResourceUrl.status) {
      case 1:
        console.log(asyncResourceUrl);
        this.isVisibleResource = true
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(asyncResourceUrl.data.url);


        break;
      case 2:
        Utils.error(asyncResourceUrl.data)
        this.utils.toast.error()
        break
      default:
        break;
    }
    this.messageService.clear()
  }


  onSolveUser() {



    if (this.form.reject === 1) {
      this.form = {
        ...this.form,
        user_id: this.itemSelected.user_id,
        status_: 0,
        approval_status: 'REJECTED',
        user_credential_status_: 0
      }
    } else {
      this.form = {
        ...this.form,
        user_id: this.itemSelected.user_id,
        status_: 1,
        approval_status: 'ACCEPTED',
        user_credential_status_: 1
      }
    }
    this.data.core.solveUser(this.form).subscribe(data=> {
      this.solveDialogVisible = false
      this.utils.toast.saved(this.title)
      this.getList();
    })


  }





}
